import { render, staticRenderFns } from "./Mymailscore.vue?vue&type=template&id=60ed3134&scoped=true"
import script from "./Mymailscore.vue?vue&type=script&lang=js"
export * from "./Mymailscore.vue?vue&type=script&lang=js"
import style0 from "./Mymailscore.vue?vue&type=style&index=0&id=60ed3134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed3134",
  null
  
)

export default component.exports